// extracted by mini-css-extract-plugin
export default {"appointments":"qVz7fT","appointments__cta":"AxoTCh"};